import { useTranslation } from 'react-i18next'

import { FormLayout, SubmitButton } from '@ana/shared'
import { LayoutItem, Form } from '@ana/shared'
import PageLayout from 'components/PageLayout'
import ReferralItem from 'components/ReferralItem'
import referralSources from 'config/referralSources'
import { Field, FieldProps, Formik } from 'formik'
import { PageProps } from 'hooks/usePage'
import useSaveOnBack from 'hooks/useSaveOnBack'

export type ReferralScreenProps = PageProps

const layout: LayoutItem[] = referralSources.map((source) => ({
  type: 'custom',
  xs: 6,
  key: source.label,
  render: () => {
    return <ReferralItem referralKey={source.label} label={`option.${source.label}`} Icon={source.icon} />
  },
}))

const ReferralScreen: React.FC<ReferralScreenProps> = ({ initialValues = {}, onSubmit, onBack }) => {
  const formikRef = useSaveOnBack({ onBack })
  const { t } = useTranslation()

  const handleSubmit = (values: Partial<Form>) => onSubmit(values)

  const submitButton = (
    <Field>
      {(props: FieldProps) => {
        return (
          <SubmitButton
            loading={false}
            name={t('next', { postProcess: [] })}
            type="submit"
            disabled={!props.form.isValid}
          >
            {t('next')}
          </SubmitButton>
        )
      }}
    </Field>
  )

  return (
    <PageLayout title={t('subcategory.how_did_you_hear_from_us')} subtitle={t('subcategory.referral')}>
      <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit}>
        {(formikProps) => (
          <form onSubmit={formikProps.handleSubmit}>
            <FormLayout items={layout} submitButton={submitButton} spacingX={2} spacingY={2} />
          </form>
        )}
      </Formik>
    </PageLayout>
  )
}

export default ReferralScreen
